import { Route, useLocation, Routes } from "react-router-dom";
import Signup from "./pages/auth/signup/page";
import DashboardPage from "./pages/dashboard/main";
import Login from "./pages/auth/login/admin/page";
import Terminal from "./pages/dashboard/terminal/page";
import Merchant from "./pages/dashboard/merchant/page";
import Transaction from "./pages/dashboard/transaction/page";
import Dashboard from "./pages/dashboard/index/page";
import MerchantDashboardLayout from "./pages/merchant-dashboard/layout";
import MerchantDashboard from "./pages/merchant-dashboard/index/page";
import MerchantSignup from "./pages/auth/merchant-signup/page";
import Transactions from "./pages/merchant-dashboard/transactions/page";
import Terminals from "./pages/merchant-dashboard/terminals/page";
import ChangePassword from "./pages/merchant-dashboard/change-password/page";
import MerchantUserPage from "./pages/dashboard/merchant-users/page";
import MerchantUsers from "./pages/merchant-dashboard/users/page";
import TransactionReport from "./pages/dashboard/transaction-report/page";
import EJournal from "./pages/dashboard/e-journal/page";
import ForgotPassword from "./pages/auth/forgot-password/page";
import ResetPassword from "./pages/auth/reset-password/page";
import TerminalHealths from "./pages/dashboard/terminal-health/page";
import PwtTransactions from "./pages/dashboard/pwt-transactions/page";
const PagesRoutes = () => {
  const location = useLocation();

  return (
    <Routes location={location} key={location.pathname}>
      {/* <Route path="/dashboard" element={<DashboardPage />} /> */}
      <Route path="/" element={<Login />} />
      <Route path="/signup" element={<Signup />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/resetpassword" element={<ResetPassword />} />
      <Route path="/client-merchant/invite" element={<MerchantSignup />} />
      <Route path="dashboard" element={<DashboardPage />}>
        <Route index element={<Dashboard />} />
        <Route path="terminal" element={<Terminal />} />
        <Route path="merchant" element={<Merchant />} />
        <Route path="merchant-users" element={<MerchantUserPage />} />
        <Route path="transaction" element={<Transaction />} />
        <Route path="pwt-transaction" element={<PwtTransactions />} />
        <Route path="transaction-report" element={<TransactionReport />} />
        <Route path="terminal-health" element={<TerminalHealths />} />
        <Route path="e-journal" element={<EJournal />} />
      </Route>
      <Route path="merchant-dashboard" element={<MerchantDashboardLayout />}>
        <Route index element={<MerchantDashboard />} />
        <Route path="transactions" element={<Transactions />} />
        <Route path="terminals" element={<Terminals />} />
        <Route path="users" element={<MerchantUsers />} />
        <Route path="change-password" element={<ChangePassword />} />
      </Route>
      <Route path="*" element={<Login />} />
    </Routes>
  );
};

export default PagesRoutes;
